import axios from "axios";
import { getRouteUrl, getRoutesByMapSlugUrl } from "./ServiceUrls";
import { createClient } from "@supabase/supabase-js";

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default class ZipmapRouteRepository {
    async getRouteDetails(mapSlug, routeSlug) {
        const session = await supabase.auth.getSession()
        const headers = {}
        if (session.data.session) {
            headers['Authorization'] = `Bearer ${session.data.session.access_token}`
        }
        let response = await axios.get(
            getRouteUrl(mapSlug, routeSlug),
            {
                headers: headers
            }
        );
        console.log(response.data)
        return response.data
    }


    async getRoutesByMapSlug(mapSlug) {
        const session = await supabase.auth.getSession()
        const headers = {}
        if (session.data.session) {
            headers['Authorization'] = `Bearer ${session.data.session.access_token}`
        }
        const response = await axios.get(
            getRoutesByMapSlugUrl(mapSlug),
            {
                headers: headers
            }
        )
        return response.data
    }

}